import {http} from '../utils'
// 营销分组管理 start
// 查询
const searchAction = (params) => {
  const url = `/market/ai/task/page`
  return http.post(url, params)
}
// 获取用户列表
const getAuditUsers = () => {
  const url = '/api/v1/users/all'
  return http.post(url)
}
// 获取status列表
const getStatus = (type) => {
  const url = `/market/common/codeList/${type}`
  return http.post(url)
}
// 展会届次列表
const expoAction = (params) => {
  const url = `/market/common/resume`
  return http.post(url, params)
}
// 获取 详情
const getAction = (id) => {
  const url = `/market/management/task/detail/${id}`
  return http.post(url)
}
// 新建
const addAction = (params) => {
  const url = `/market/ai/task/submit/save`
  return http.post(url, params)
}
// 修改禁用启用
const statusAction = (params) => {
  const url = `/market/management/group/changeStatus`
  return http.post(url, params)
}
// 删除
const deleteAction = (id) => {
  const url = `/market/ai/task/delete/${id}`
  return http.post(url)
}
// 关闭
const closeAction = (id) => {
  const url = `/market/ai/task/close/${id}`
  return http.post(url)
}
// 暂停
const pauseAction = (id) => {
  const url = `/market/ai/task/pauseOrResume/${id}`
  return http.post(url)
}
// 重试
const retryAction = (id) => {
  const url = `/market/ai/task/member/upload/retry/${id}`
  return http.post(url)
}

// 项目组管理分组设置
const groupLogSave = (params) => {
  const url = `/market/common/group/log/save`
  return http.post(url, params)
}

// 项目组管理分组设置列表
const groupLogList = (params) => {
  const url = `/market/common/group/log/list`
  return http.post(url, params)
}
// 添加号码
const addPhoneAction = (params) => {
  const url = `/market/ai/task/import/manual`
  return http.post(url, params)
}
const addPoolPhoneAction = (params) => {
  const url = `/market/ai/task/import/pool`
  return http.post(url, params)
}
// 查询
const phoneAction = (params) => {
  const url = `/market/ai/task/import/page`
  return http.post(url, params)
}
// 删除所有号码
const deletePhoneAction = (params) => {
  const url = `/market/ai/task/import/clear`
  return http.post(url, params)
}
// 删除某条号码
const deleteOnePhoneAction = (id) => {
  const url = `/market/ai/task/import/clear/${id}`
  return http.post(url)
}
// 清空号码
const clearPhoneAction = (id) => {
  const url = `/market/ai/task/import/delete/${id}`
  return http.post(url)
}
// 场景模型列表
const modelList = (params) => {
  const url = `/market/ai/model/list`
  return http.post(url, params)
}
// 主叫号码列表
const callerList = (params) => {
  const url = `/market/ai/task/caller/list`
  return http.post(url, params)
}
// 获取getResourcePool列表
const getResourcePool = (params) => {
  const url = '/market/management/resource/all'
  return http.post(url, params)
}
// 获取手机号统计结果
const statisticsAction = (id) => {
  const url = `/market/ai/task/import/statistic/${id}`
  return http.post(url)
}
// 发送测试短信
const sendTestPhone=(params)=>{
  const url = `/market/ai/task/test/save`
  return http.post(url,params)
}
// 同意 拒绝
const agreeAction = (params) => {
  const url = `/market/ai/task/approve/save`
  return http.post(url,params)
}
export default {
  searchAction,
  getAuditUsers,
  getStatus,
  expoAction,
  getAction,
  addAction,
  statusAction,
  deleteAction,
  closeAction,
  pauseAction,
  groupLogSave,
  groupLogList,
  addPhoneAction,
  addPoolPhoneAction,
  phoneAction,
  deletePhoneAction,
  deleteOnePhoneAction,
  clearPhoneAction,
  modelList,
  callerList,
  getResourcePool,
  statisticsAction,
  sendTestPhone,
  agreeAction,
  retryAction,
}
